import { ColorEnum, Icon } from './icon';
import { CheckmarkIcon } from '../../../../../icons';

export const CheckedIcon = ({ color }: { color?: ColorEnum }) => (
  <Icon color={color} state="checked">
    <CheckmarkIcon height="inherit" width="inherit" />
  </Icon>
);
